module.exports = __webpack_public_path__ + "assets/learn.50c442df.svg";